import { render, staticRenderFns } from "./DelegationInfoMenu.vue?vue&type=template&id=79e21025&scoped=true&"
import script from "./DelegationInfoMenu.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoMenu.vue?vue&type=script&lang=js&"
import style0 from "./DelegationInfoMenu.vue?vue&type=style&index=0&id=79e21025&scoped=true&lang=css&"
import style1 from "./DelegationInfoMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e21025",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e21025')) {
      api.createRecord('79e21025', component.options)
    } else {
      api.reload('79e21025', component.options)
    }
    module.hot.accept("./DelegationInfoMenu.vue?vue&type=template&id=79e21025&scoped=true&", function () {
      api.rerender('79e21025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationInfoMenu.vue"
export default component.exports